
import * as types from './types'

export const setCachedActivityState = ({ commit }, data) => {
  commit(types.SET_CACHED_ACTIVITY_STATE, data)
}

export const setDetailActivityState = ({ commit }, data) => {
  commit(types.SET_DETAIL_ACTIVITY_STATE, data)
}
